import { Capacitor } from "@capacitor/core";
import { getPanelInterviews, getInterviewData } from "@/utils/apiFunctions";
import JobDetailsModal from "@/views/PanelDashboard/modals/JobDetailsModal";
import DateField from "@/components/InputComponents/DateField";
import capacitorDownload from "@/components/mixin/capacitorDownload";
import "@/assets/newdesign/transaction/transaction.css";
export default {
	mixins: [capacitorDownload],
	data() {
		return {
			cardLoading: false,
			filterText: null,
			showExportFilter: false,
			interviewInfo: null,
			totalPages: null,
			enableColSort: false,
			toggleFilter: false,
			goToPage: null,
			filtered: false,
			showExportExcel: false,
			selectedFilter: null,
			options: [
				{ text: "All", value: 4 },
				{ text: "Pending", value: 1 },
				{ text: "Completed", value: 2 },
				{ text: "Cancelled", value: 0 },
			],
			showFilter: false,
			interviews: [],
			page: 1,
			pageCount: 10,
			searchQuery: null,
			filterColumn: "createdAt",
			order: -1,
			filters: {
				paymentStatus: null,
			},
			fromDate: null,
			toDate: null,
			transactionLoading: false,
			showPublic: false,
			selectedInterview: {},
			showJobDetailsModal: false,
			loadingMore: false,
			pageEnd: 0,
			pageStart: 0,
			total: 0,
		};
	},
	created() {
		this.getPanelInterviews();
	},
	components: {
		JobDetailsModal,
		DateField,
	},
	methods: {
		async getInterviewData() {
			this.cardLoading = true;
			const res = await getInterviewData();
			if (res.status == 200) {
				this.interviewInfo = res.data.data;
				// this.interviewInfo.experience = [1, 4, 5];
				this.cardLoading = false;
			}
		},
		updateFromDate(date) {
			this.fromDate = date;
		},
		updateToDate(date) {
			this.toDate = date;
		},
		closeExport() {
			this.showExportExcel = false;
		},
		resetExportFilter() {
			this.fromDate = null;
			this.toDate = null;
		},
		applyExportFilter() {
			this.getPanelInterviews(true);
			this.showExportFilter = false;
		},
		goBack() {
			this.$router.push({
				name: "Transaction",
			});
		},
		applyFilter() {
			const selectedOption = this.options.find(
				(item) => item.value === this.selectedFilter
			);

			this.filters = {
				paymentStatus: selectedOption?.value ?? null,
			};
			this.page = 1;
			this.filterText = selectedOption?.text ?? "";
			this.filtered = this.filterText !== "All";
			this.searchQuery = null;
			this.showFilter = false;
			this.getPanelInterviews();
		},
		resetFilter() {
			this.filters = {
				paymentStatus: null,
			};
			this.filterText = "Select";
			this.filtered = false;
			this.selectedFilter = null;
			this.showFilter = false;
			this.interviews = [];
			this.getPanelInterviews();
		},

		closeFilter() {
			this.showFilter = false;
		},
		onScroll(e) {
			const { target } = e;
			const isAtBottom =
				target.scrollTop + target.offsetHeight >= target.scrollHeight - 5;
			if (isAtBottom && !this.loadingMore) {
				if (this.pageEnd < this.total) {
					this.loadingMore = true;
					this.page++;
					this.getPanelInterviews(false, false);
				}
			}
		},
		hideJobDetails() {
			this.showJobDetailsModal = false;
		},
		openJobDetails(interview, index) {
			this.selectedInterview = { ...interview };
			// if (window.innerWidth < 1024) {
			// 	this.$store.commit("candidateVUEX/setInterview", {
			// 		interview: interview,
			// 		level: 2,
            //         transaction: true,
			// 	});
			// 	this.$nextTick(() => {
			// 		let route = { name: "JobDetails" };
			// 		if (this.$route.name == "TransactionMob" || this.$route.name == "Transaction") {
			// 			route.query = {
			// 				from: this.$route.name,
			// 				level: 2,
			// 			};
			// 		}
			// 		this.$router.push(route);
			// 	});
			// } else {
				this.showJobDetailsModal = true;
			// }
		},
		async getPanelInterviews(download = false, loader = true) {
			try {
				this.transactionLoading = download || !loader ? false : true;
				let payload = {};
				if (this.filters.paymentStatus == 4) {
					this.filters.paymentStatus = null;
				}
				if (this.searchQuery) this.filters.paymentStatus = null;
				if (download) {
					payload = {
						excel: download,
						startDate: this.fromDate.replace(/-/g, "."),
						endDate: this.toDate.replace(/-/g, "."),
						transaction: true,
					};
				} else {
					payload = {
						excel: download,
						page: this.page > 0 ? this.page - 1 : this.page,
						count: this.pageCount,
						searchQuery: this.searchQuery,
						transaction: true,
						sortBy: {
							column: this.filterColumn,
							order: this.order,
						},
					};
					if (this.filters.paymentStatus !== null) {
						payload["filters"] = this.filters;
					}
				}
				
				const res = await getPanelInterviews(payload);
				if (download) {
					const blob = new Blob([res.data], {
						type: "application/vnd.ms-excel",
					});
					if (Capacitor.isNativePlatform()) {
						await this.saveBlobToDevice(blob, "interviews.xls", {
							resumePrefix: false,
						});
					} else {
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute("download", "interviews.xls");
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
					}
					this.transactionLoading = false;
					this.showExportExcel = false;
					return;
				}
				if (res.status == 200) {
					if (this.searchQuery || this.filters.paymentStatus !== null) {
						this.interviews = [];
					}
					this.interviews = [...this.interviews, ...res.data.data.data];
					this.totalPages = res.data.data.total;
					this.pageEnd = res.data.data.pageEnd;
					this.pageStart = res.data.data.pageStart;
					this.total = res.data.data.total;
					this.transactionLoading = false;
					this.loadingMore = false;
				}
			} catch (error) {
				console.log("error");
			}
		},
	},
};
